import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/apiClient";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [stats, setStats] = useState({ available_count: 0, cheapest_price: null });

  const refresh = useCallback(async () => {
    try {
      const [s, st] = await Promise.all([api.get("/settings"), api.get("/stats")]);
      setSettings(s.data);
      setStats(st.data);
    } catch (e) {
      console.error("Failed to load site data", e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const whatsappNumber = settings?.whatsapp_number || "447561556057";

  return (
    <SiteContext.Provider value={{ settings, stats, whatsappNumber, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used within SiteProvider");
  return ctx;
}
